import { GAME_LIST_FETCH_SIZE } from '~/features/character/useGetMissionGameListQuery';
import { COMMENT_FETCH_SIZE } from '~/features/comment/useGetCommentListQuery';
import {
  EmptyResponse,
  PaginationRequest,
  CreateGameChatRoomRequest,
  CreateGameCommentRequest,
  CreateGameCommentResponse,
  DeleteGameCommentRequest,
  DeleteGameEmojiRequest,
  GetGameChatroomInfoRequest,
  GetGameChatroomInfoResponse,
  GetGameChatroomListResponse,
  GetGameCommentListRequest,
  GetGameCommentListResponse,
  GetGameListResponse,
  GetGameResponse,
  GetPreviousGameChatListRequest,
  GetPreviousGameChatListResponse,
  LikeGameCommentRequest,
  PostGameEmojiRequestData,
  SubmitGameMissionRequestData,
  SubmitGameMissionResponseData,
  UnlikeGameCommentRequest,
  UpdateGameCommentRequest,
} from '~/types';
import { fetcher } from './config/fetcher';
import http from './config/http';

// 안쓰는 API
export const createGameChatRoom = async ({
  game_id,
  ...request
}: CreateGameChatRoomRequest) => {
  return fetcher(() =>
    http.post<EmptyResponse>(`/missions/${game_id}/chatrooms`, request),
  );
};

export const createGameComment = async ({
  game_id,
  ...request
}: CreateGameCommentRequest) => {
  return fetcher(() =>
    http.post<CreateGameCommentResponse>(
      `/missions/${game_id}/comments`,
      request,
    ),
  );
};

export const deleteGameComment = async ({
  game_id,
  comment_id,
}: DeleteGameCommentRequest) => {
  return fetcher(() =>
    http.delete<EmptyResponse>(`/missions/${game_id}/comments/${comment_id}`),
  );
};

export const deleteGameEmoji = async ({
  game_id,
  emoji_id,
}: DeleteGameEmojiRequest) => {
  return fetcher(() =>
    http.delete<EmptyResponse>(`/missions/${game_id}/emojis/${emoji_id}`),
  );
};

export const likeGameComment = async ({
  game_id,
  comment_id,
}: LikeGameCommentRequest) => {
  return fetcher(() =>
    http.post<EmptyResponse>(
      `/missions/${game_id}/comments/${comment_id}/likes`,
    ),
  );
};

export const likeGame = async ({ game_id }: { game_id: number }) => {
  return fetcher(() => http.post<EmptyResponse>(`/missions/${game_id}/likes`));
};

// export const getGameChatroomBackgroundList = async () => {
//   return fetcher(() =>http.post<GetGameChatroomBackgroundListResponse>(
//     '/mission/listChatroomBackground',
//   );
//     return { data: res.data, status: res.status };
// };
// export const getGameChatroomBgmList = async () => {
//   return fetcher(() =>http.post<GetGameChatroomBgmListResponse>(
//     '/mission/listChatroomBgm',
//   );
//     return { data: res.data, status: res.status };
// };

export const getGameCommentsList = async ({
  game_id,
  page,
  sort_by,
}: PaginationRequest<GetGameCommentListRequest>) => {
  return fetcher(() =>
    http.get<GetGameCommentListResponse>(`/missions/${game_id}/comments`, {
      params: {
        sort_by,
        page,
        page_size: COMMENT_FETCH_SIZE,
      },
    }),
  );
};

export const getGameList = async ({ page }: PaginationRequest<void>) => {
  return fetcher(() =>
    http.get<GetGameListResponse>(`/missions`, {
      params: { page, page_size: GAME_LIST_FETCH_SIZE },
    }),
  );
};

export const getPreviousGameChatList = async ({
  game_id,
  game_chat_id,
  last_evaluated_key,
}: GetPreviousGameChatListRequest) => {
  return fetcher(() =>
    http.get<GetPreviousGameChatListResponse>(
      `/missions/${game_id}/chatrooms/${game_chat_id}/chats`,
      {
        params: {
          last_evaluated_key,
        },
      },
    ),
  );
};

export const getGame = async ({ game_id }: { game_id: number }) => {
  return fetcher(() => http.get<GetGameResponse>(`/missions/${game_id}`));
};

export const getGameChatroomList = async ({ game_id }: { game_id: number }) => {
  return fetcher(() =>
    http.get<GetGameChatroomListResponse>(`/missions/${game_id}/chatrooms`),
  );
};

export const postGameEmoji = async ({
  game_id,
  emoji_id,
}: PostGameEmojiRequestData) => {
  return fetcher(() =>
    http.post<EmptyResponse>(`/missions/${game_id}/emojis/${emoji_id}`),
  );
};

export const submitGameMission = async ({
  game_id,
  ...request
}: SubmitGameMissionRequestData) => {
  return fetcher(() =>
    http.post<SubmitGameMissionResponseData>(
      `/missions/${game_id}/submissions `,
      request,
    ),
  );
};

export const unlikeGameComment = async ({
  game_id,
  comment_id,
}: UnlikeGameCommentRequest) => {
  return fetcher(() =>
    http.delete<EmptyResponse>(
      `/missions/${game_id}/comments/${comment_id}/likes`,
    ),
  );
};

export const unlikeGame = async ({ game_id }: { game_id: number }) => {
  return fetcher(() =>
    http.delete<EmptyResponse>(`/missions/${game_id}/likes`),
  );
};

export const updateGameComment = async ({
  game_id,
  comment_id,
  comment,
}: UpdateGameCommentRequest) => {
  return fetcher(() =>
    http.put<EmptyResponse>(`/missions/${game_id}/comments/${comment_id}`, {
      comment,
    }),
  );
};

export const getGameChatroomInfo = async ({
  game_chat_id,
  game_id,
}: GetGameChatroomInfoRequest) => {
  return fetcher(() =>
    http.get<GetGameChatroomInfoResponse>(
      `/missions/${game_id}/chatrooms/${game_chat_id}`,
    ),
  );
};

export const exitGame = async ({ game_id }: { game_id: number }) => {
  return fetcher(() =>
    http.delete<EmptyResponse>(`/missions/${game_id}/connections`),
  );
};
